/**
 * Menu principal : SEULE définition des entrées. Chaque lien n'apparaît que si
 * l'utilisateur a l'une des permissions de la page (meta.permissions du
 * routeur) et si le module de la page est compris dans l'offre de la clinique.
 */
import { moduleDe } from './modules'

export const SECTIONS = [
  { cle: 'tableau', libelle: 'Tableau de bord', icone: 'bi-speedometer2', to: '/' },
  { cle: 'patients', libelle: 'Patients', icone: 'bi-people', to: '/patients' },
  {
    cle: 'accueil', libelle: 'Accueil', icone: 'bi-door-open', liens: [
      { to: '/salle-attente', libelle: "Salle d'attente" },
      { to: '/rendez-vous', libelle: 'Rendez-vous' },
      { to: '/heures-consultation', libelle: 'Heures de consultation' },
      { to: '/accueil-hors-ligne', libelle: 'Accueil hors connexion', horsLigne: true },
      { to: '/journal-sms', libelle: 'Journal des SMS' },
    ],
  },
  { cle: 'consultations', libelle: 'Consultations', icone: 'bi-clipboard2-pulse', to: '/consultations_' },
  { cle: 'laboratoire', libelle: 'Laboratoire', icone: 'bi-eyedropper', to: '/laboratoire' },
  {
    cle: 'banqueSang', libelle: 'Banque de sang', icone: 'bi-droplet-half', liens: [
      { to: '/banque-sang', libelle: 'Tableau de bord' },
      { to: '/banque-sang/demandes', libelle: 'Demandes de transfusion' },
      { to: '/banque-sang/transfusions', libelle: 'Transfusions' },
      { to: '/banque-sang/poches', libelle: 'Stock de poches' },
      { to: '/banque-sang/donneurs', libelle: 'Donneurs' },
    ],
  },
  {
    cle: 'hospitalisation', libelle: 'Hospitalisation', icone: 'bi-hospital', liens: [
      { to: '/hospitalisations', libelle: 'Hospitalisations' },
      { to: '/chambres', libelle: 'État des chambres' },
    ],
  },
  {
    cle: 'pharmacie', libelle: 'Pharmacie', icone: 'bi-capsule', liens: [
      { to: '/ventes/create', libelle: 'Vendre', permissions: ['NOUVELLE_VENTE'] },
      { to: '/ventes', libelle: 'Ventes' },
      { to: '/produits', libelle: 'Produits' },
      { to: '/stocks-lots', libelle: 'Stock et péremptions' },
      { to: '/approvs', libelle: 'Réceptions fournisseurs' },
    ],
  },
  {
    cle: 'caisse', libelle: 'Caisse', icone: 'bi-cash-coin', liens: [
      { to: '/paiements', libelle: 'Encaissements' },
      { to: '/finances/caisses', libelle: 'Contrôle des caisses' },
      { to: '/prises-en-charge-sociales', libelle: 'Prises en charge sociales' },
      { to: '/paiements-en-ligne', libelle: 'Paiements en ligne' },
    ],
  },
  {
    cle: 'assurances', libelle: 'Assurances', icone: 'bi-shield-check', liens: [
      { to: '/creances-assurance', libelle: 'Créances et bordereaux' },
      { to: '/assurances', libelle: 'Assureurs et tarifs' },
    ],
  },
  {
    cle: 'finances', libelle: 'Finances', icone: 'bi-graph-up', liens: [
      { to: '/finances/rapports', libelle: 'Rapports' },
      { to: '/finances/depenses', libelle: 'Dépenses' },
      { to: '/finances/honoraires', libelle: 'Honoraires des médecins' },
    ],
  },
  {
    cle: 'configuration', libelle: 'Configuration', icone: 'bi-sliders', liens: [
      { to: '/type_consultations', libelle: 'Types de consultation' },
      { to: '/services', libelle: 'Examens et services' },
      { to: '/type_services', libelle: 'Catégories de services' },
      { to: '/moyen_paiements', libelle: 'Moyens de paiement' },
      { to: '/frequences', libelle: 'Posologies' },
      { to: '/duree_medicaments', libelle: 'Durées de traitement' },
      { to: '/conditionnements', libelle: 'Conditionnements' },
      { to: '/type_chambres', libelle: 'Types de chambre' },
      { to: '/lits', libelle: 'Lits' },
      { to: '/type_hospitalisations', libelle: "Types d'hospitalisation" },
      { to: '/type_examens', libelle: "Types d'examen" },
    ],
  },
  {
    cle: 'administration', libelle: 'Administration', icone: 'bi-gear', liens: [
      { to: '/premiers-pas', libelle: 'Premiers pas' },
      { to: '/utilisateurs', libelle: 'Utilisateurs' },
      { to: '/roles', libelle: 'Rôles et permissions' },
      { to: '/configurations', libelle: 'Configuration de la clinique' },
      { to: '/journal-activite', libelle: "Journal d'activité" },
      { to: '/protection-donnees', libelle: 'Protection des données' },
      { to: '/paiement-en-ligne/configuration', libelle: 'Paiement en ligne' },
    ],
  },
  { cle: 'abonnement', libelle: 'Mon abonnement', icone: 'bi-patch-check', to: '/mon-abonnement' },
  { cle: 'aide', libelle: "Guide d'utilisation", icone: 'bi-life-preserver', to: '/aide' },
]

/**
 * Le lien est-il accessible ?
 * @param {object} lien { to, permissions?, horsLigne? }
 * @param {object} contexte { router, getters, horsLigne: () => bool }
 */
export function visible(lien, { router, getters, horsLigne }) {
  if (lien.horsLigne && !horsLigne()) return false
  const module = moduleDe(lien.to)
  if (module && !getters.hasModule(module)) return false
  let perms = lien.permissions
  if (!perms) {
    const route = router.resolve(lien.to)
    perms = route?.meta?.permissions
    if (route?.meta?.module && !getters.hasModule(route.meta.module)) return false
  }
  return !perms || !perms.length || getters.hasAnyPermission(perms)
}

/** Sections visibles, avec leurs seuls liens accessibles. */
export function menuVisible(contexte) {
  return SECTIONS.map(s => {
    if (s.to) return visible(s, contexte) ? s : null
    const liens = s.liens.filter(l => visible(l, contexte))
    return liens.length ? { ...s, liens } : null
  }).filter(Boolean)
}
